import { endPoint } from "./base.config";

export const localRule = {
  add: `${endPoint}localRules`,
  update: `${endPoint}localRules/:id`,
  delete: `${endPoint}localRules/:id`,
  fetchAll: `${endPoint}localRules`,
  copy: `${endPoint}localRules/copy`,
}